import { IProjectCollateralSubcategory } from '~/@api/generated-api-types-project/Api'
import type { ObjectValues } from '~/@lib/utils/type.utils'
import { ProjectCollateralCategory } from './projectCollateralCategory'
import { getProjectCollateralSubcategoryLabel } from '../_projects_ui/project-collateral/labelByCollateralSubcategory'

export type ProjectCollateralSubcategory = ObjectValues<
  typeof IProjectCollateralSubcategory
>

export const ProjectCollateralSubcategoryMapping: Map<
  ProjectCollateralCategory,
  ProjectCollateralSubcategory[]
> = new Map([
  [
    ProjectCollateralCategory.Residential,
    [
      IProjectCollateralSubcategory.Flat,
      IProjectCollateralSubcategory.House,
      IProjectCollateralSubcategory.Apartman,
    ],
  ],
  [
    ProjectCollateralCategory.Commercial,
    [
      IProjectCollateralSubcategory.Office,
      IProjectCollateralSubcategory.CommercialSpace,
      IProjectCollateralSubcategory.Polyfunction,
    ],
  ],
  [
    ProjectCollateralCategory.Land,
    [
      IProjectCollateralSubcategory.BuildingLands,
      IProjectCollateralSubcategory.Meadow,
      IProjectCollateralSubcategory.Garage,
      IProjectCollateralSubcategory.OtherLand,
    ],
  ],
  [
    ProjectCollateralCategory.Recreational,
    [
      IProjectCollateralSubcategory.Hotel,
      IProjectCollateralSubcategory.Pension,
      IProjectCollateralSubcategory.Cottage,
      IProjectCollateralSubcategory.Accommodation,
    ],
  ],
  [
    ProjectCollateralCategory.Other,
    [
      IProjectCollateralSubcategory.GasStation,
      IProjectCollateralSubcategory.Logistics,
      IProjectCollateralSubcategory.ManufacturingArea,
      IProjectCollateralSubcategory.Warehouse,
      IProjectCollateralSubcategory.Garage,
      IProjectCollateralSubcategory.RealEstate,
      IProjectCollateralSubcategory.Other,
    ],
  ],
])

export const ProjectCollateralSubcategoryArray = (function () {
  return Object.values(IProjectCollateralSubcategory).map((value) => {
    return {
      value,
      text: getProjectCollateralSubcategoryLabel(value),
    }
  })
})()
